var map = {
	"./3.png": 3283,
	"./AlmacenamientoEnergia.svg": 1893,
	"./AlmacenamientoEnergiaW.png": 8112,
	"./BioElectronica.png": 771,
	"./BioElectronica.svg": 7447,
	"./BioElectrónica.png": 1359,
	"./BioElectrónica.svg": 9331,
	"./BiosensoresElectro.svg": 354,
	"./BiosensoresElectro2.svg": 7983,
	"./BiosensoresElectro2W.png": 6487,
	"./ConversionEnergia.svg": 1723,
	"./ConversionEnergiaW.png": 2174,
	"./MusculosArtificiales.svg": 6603,
	"./MusculosArtificialesW.png": 6744,
	"./Nanomateriales.svg": 3627,
	"./NanomaterialesW.png": 3476,
	"./logotejidosR.svg": 3613,
	"./logotejidosR1.png": 3952,
	"./mecatronicaR.png": 6100,
	"./mecatronicaR.svg": 8560,
	"./path11826.png": 6217,
	"./path5019.png": 2210,
	"./software.png": 5925,
	"./software.svg": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6272;